module.exports = {
  en: {
    'HRMS73E1': {
      '10': 'For Year',
      '20': 'Course',
      '30': 'Class No.',
      '40': 'For Department',
      '50': 'Or Employee Code',
      '60': 'Emp. Code',
      '70': 'First Name - Last Name',
      '80': 'Training date',
      '90': 'Start date',
      '100': 'End date',
      '110': 'Assessment By',
      '120': 'Assessment date'
    },
    'HRMS73E2': {
      '10': 'For Year',
      '20': 'Course',
      '30': 'Class No.',
      '40': 'Emp. Code',
      '50': 'Assessment Code',
      '60': 'Assessment date',
      '70': 'Assessment Form',
      '80': 'Sec.',
      '90': 'Detail',
      '100': 'Full score',
      '110': 'Scores',
      '120': 'Total',
      '130': 'Suggestions / things that need improvement'
    },
    'HRMS73E3': {
      '10': 'Assessment Form',
      '20': 'Emp. Code',
      '30': 'Assessment Code',
      '40': 'Assessment date',
      '50': 'Sec.',
      '60': 'Detail',
      '70': 'Full',
      '80': 'Score',
      '90': 'Score',
      '100': 'Total',
      '110': 'No.',
      '120': 'Detail',
      '130': 'Weight',
      '140': 'Grade',
      '150': 'Score',
      '160': 'Total'
    }
  },
  th: {
    'HRMS73E1': {
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'สำหรับหน่วยงาน',
      '50': 'หรือ รหัสพนักงาน',
      '60': 'รหัสพนักงาน',
      '70': 'ชื่อ - นามสกุล',
      '80': 'วันที่อบรม',
      '90': 'วันที่เริ่ม',
      '100': 'วันที่สิ้นสุด',
      '110': 'ประเมินโดย',
      '120': 'วันที่ประเมิน'
    },
    'HRMS73E2': {
      '10': 'สำหรับปี',
      '20': 'หลักสูตร',
      '30': 'รุ่นที่',
      '40': 'รหัสพนักงาน',
      '50': 'รหัสผู้ประเมิน',
      '60': 'วันที่ประเมิน',
      '70': 'แบบฟอร์มการประเมิน',
      '80': 'ส่วนที่',
      '90': 'รายละเอียด',
      '100': 'คะแนนเต็ม',
      '110': 'คะแนนที่ได้',
      '120': 'รวม',
      '130': 'ข้อเสนอแนะ/สิ่งที่ต้องปรับปรุง'
    },
    'HRMS73E3': {
      '10': 'รหัสแบบฟอร์มประเมิน',
      '20': 'รหัสพนักงาน',
      '30': 'รหัสผู้ประเมิน',
      '40': 'วันที่ประเมิน',
      '50': 'ส่วนที่',
      '60': 'รายละเอียด',
      '70': 'คะแนน',
      '80': 'เต็ม',
      '90': 'คะแนนที่ได้',
      '100': 'รวม',
      '110': 'ข้อที่',
      '120': 'รายละเอียด',
      '130': 'Weight',
      '140': 'Grade',
      '150': 'คะแนนที่ได้',
      '160': 'รวม'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms73e.js